import { ChartBar } from "./ChartBar";
import { ChartDonut } from "./ChartDonut";
import { ChartLine } from "./ChartLine";
import { ChartArea } from "./ChartArea";
import { ChartPie } from "./ChartPie";
import { ChartSparkline } from "./ChartSparkline";
import { ChartHorizontalBar } from "./ChartHorizontalBar";
import { ChartStackedBar } from "./ChartStackedBar";

export const Chart = {
  Bar: ChartBar,
  Donut: ChartDonut,
  Line: ChartLine,
  Area: ChartArea,
  Pie: ChartPie,
  Sparkline: ChartSparkline,
  HorizontalBar: ChartHorizontalBar,
  StackedBar: ChartStackedBar,
};
